import { Link } from "react-router-dom";
import { getChannel } from "@/mocks/channels";
import { getArticlesByChannel } from "@/mocks/articles";
import { toneClasses } from "@/lib/ui";
import ArticleCard from "@/components/feature/ArticleCard";

export default function ChannelListCard({
  channelSlug,
  limit = 4,
}: {
  channelSlug: string;
  limit?: number;
}) {
  const channel = getChannel(channelSlug);
  if (!channel) return null;
  const tone = toneClasses[channel.tone];
  const list = getArticlesByChannel(channelSlug).slice(0, limit);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3.5">
        <div className="flex items-center gap-2.5">
          <span className={`flex h-7 w-7 items-center justify-center rounded-md ${tone.bgSoft} ${tone.textStrong}`}>
            <i className={`${channel.icon} text-base`} />
          </span>
          <div>
            <h2 className="font-heading text-base font-bold text-foreground-950">{channel.name}</h2>
          </div>
        </div>
        <Link
          to={`/pindao/${channel.slug}`}
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          全部
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
      <div className="divide-y divide-background-200 px-2">
        {list.map((article, index) => (
          <ArticleCard key={article.slug} article={article} variant="compact" rank={index + 1} />
        ))}
      </div>
    </section>
  );
}